<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="placa" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Placa</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="renavam" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Renavam</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="tp_veiculo"
                        :options="optionsLivTpVeiculo"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="param_tp_veiculo"
                        :options="optionsParamTpVeiculo"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tração/Reboque"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
      Multiselect
  },
  data () {
    return {
      helpForm: new Form({params: []}),
      placa: '',
      renavam: '',
      optionsLivStatus: [],
      optionsLivTpVeiculo: [],
      optionsParamTpVeiculo: [],
      status: [],
      tp_veiculo: [],
      param_tp_veiculo: [],
      data_filter: []
    }
  },
  mounted() {
      this.getListItemGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {placa: this.placa,
                              renavam: this.renavam,
                              status: this.status,
                              tp_veiculo: this.tp_veiculo,
                              param_tp_veiculo: this.param_tp_veiculo}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.placa = '';  // clear the text in text input
        this.renavam = '';
        this.status = '';
        this.tp_veiculo = '';
        this.param_tp_veiculo = '';
        this.$events.fire('filter-reset');
      },
      getListItemGeral() {
          this.helpForm.post('/api/veiculo/jsonlistfiltros').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.status.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              });

              response.tp_veiculo.forEach((obj)=>
              {
                  this.optionsLivTpVeiculo.push({ label: obj.descr, value: obj.valor })
              });

              response.param_tipo_veiculo.forEach((obj)=>
              {
                  this.optionsParamTpVeiculo.push({ label: obj.descr, value: obj.partipvei_id })
              });
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this, true, false, false)
          });
      }
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
